module.exports = __webpack_public_path__ + "static/media/empty-state-multiple.427b38e4.png";